const menuItems = [
  {
    name: 'monitoringDashboard',
    children: [
      {
        name: 'monitoringDashboardAcceptance',
      },
      {
        name: 'monitoringDashboardExpiring',
      },
      {
        name: 'monitoringDashboardProcessing',
      },
      {
        name: 'monitoringDashboardToComplete',
      },
    ],
  },
  {
    name: 'baseArchives',
    children: [
      {
        name: 'offers',
      },
      {
        name: 'operations',
      },
      {
        name: 'thermostatsManagement',
      },
    ],
  },
  {
    name: 'sampleManagement',
    children: [
      {
        name: 'customerSampleAnalysesIndex',
      },
      {
        name: 'receivedSamplesIndex',
      },
      {
        name: 'workPlanning',
      },
      {
        name: 'quarantineIndex',
      },
      {
        name: 'approvalCustomerChangesIndex',
      },
    ],
  },
  {
    name: 'analysisManagement',
    children: [
      {
        name: 'insertAnalysesDataIndex',
      },
      {
        name: 'analysisStatusManagementIndex',
      },
      // {
      //   name: 'analysisWorkPlanning',
      // },
      // {
      //   name: 'printAnalysisReport',
      // },
      {
        name: 'printAnalyses',
      },
      {
        name: 'analysesSearch',
      },
      {
        name: 'analysesThermostatsSearchIndex',
      },
      {
        name: 'symbolSearchIndex',
      },
      {
        name: 'changeLog',
      },
    ],
  },
  {
    name: 'documents',
    children: [
      {
        name: 'signDocuments',
      },
      {
        name: 'familyTypesIndex',
      },
      {
        name: 'familyCategoriesIndex',
      },
      {
        name: 'advancedRevisionIndex',
      },
    ],
  },
  {
    name: 'stability',
    children: [
      {
        name: 'stabilityConfigurationsIndex',
      },
      {
        name: 'stabilityScheduleIndex',
      },
      {
        name: 'stabilityTimePointExportIndex',
      },
    ],
  },
  {
    name: 'locations',
    children: [
      {
        name: 'locationsManagementIndex',
      },
      {
        name: 'sectorsAssociation',
      },
      {
        name: 'defaultLocations',
      },
      {
        name: 'customersLocationsManagement',
      },
    ],
  },
  {
    name: 'configuration',
    children: [
      {
        name: 'usersManagement',
      },
      {
        name: 'rolesManagement',
      },
      {
        name: 'tasksIndex',
      },
      {
        name: 'signatureProfilesIndex',
      },
      {
        name: 'signatureRecipientsIndex',
      },
      {
        name: 'signatureConfig',
      },
      {
        name: 'systemConfig',
      },
    ],
  },
];

export default menuItems;
